<template>
  <div class="filter-wrapper">
    <!-- 学校 -->
    <div class="school" v-tap="{methods:handleSchoolClick}">
      <span v-text="school.campusName"></span>
      <i class="school_tri" :class="{add : isSelectSchool}"></i>
      <transition name="fade">
        <ul v-show="isSelectSchool">
          <li v-for="school,index in schools"
              v-tap="{methods:setSchool,school:school}"
              v-text="school.campusName"
              :key="index">
          </li>
        </ul>
      </transition>

    </div>
    <!-- 班级 -->
    <div class="grade" v-tap="{methods:handleGradeClick}">
      <span v-text="grade.gradeName">
      </span>
      <i class="grade_tri" :class="{add : isSelectGrade}">
      </i>

      <transition name="fade">
        <ul v-show="isSelectGrade">

          <li v-for="grade,index in grades"
              v-tap="{methods:setGrade,grade:grade}"
              v-text="grade.gradeName"
              :key="index">
          </li>

        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Teacher from '../api/teacher';
  export default{
    name: 'worker-filter',
    data() {
      return {
        isSelectSchool: false,
        isSelectGrade: false,
      };
    },
    methods: {
      handleSchoolClick() {
        this.isSelectSchool = !this.isSelectSchool;
        if (this.isSelectSchool) {
          this.isSelectGrade = false;
        }
      },
      setSchool({school}) {
        //选择校区时直接获取id调用查询班级接口
        Teacher.getAllClass(school.id).then(response =>{
          this.$store.commit('setGrade',response.rows[0]);
          this.$store.commit('setGrades',response.rows);
        }).catch(e => {
          console.log(e);
        });
        this.$store.commit('setSchool', school);
        this.isSelectSchool = false;
      },
      handleGradeClick() {
        this.isSelectGrade = !this.isSelectGrade;
        if (this.isSelectGrade) {
          this.isSelectSchool = false;
        }
      },
      setGrade({grade}) {
        // console.log(grade,'grade'); //包含id和name
        //传递班级选项
        this.$store.commit('setGrade', grade);
        this.$emit('gradeSelect');
        this.isSelectGrade = false;
      }
    },
    computed: {
      ...mapGetters({
        schools: 'schools',
        school: 'school',
        grade: 'grade',
        grades:'grades'
      })
    }
  };

</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .filter-wrapper {
    position: absolute;
    background-color: #313131;
    width: 100%;
    height: px2rem(84);
    display: flex;
    flex-direction: row;
    padding-top: px2rem(20);
    box-sizing: border-box;
    & > div {
      position: relative;
      flex: 1;
      background-color: white;
      border-radius: px2rem(7);
      font-size: px2rem(24);
      color: #7c7c7c;
      height: px2rem(44);
      margin: 0 px2rem(16);
      span {
        display: inline-block;
        height: px2rem(44);
        line-height: px2rem(44);
        margin-left: px2rem(20);
      }
      i {
        position: absolute;
        top: px2rem(8);
        right: px2rem(15);
        display: inline-block;
        height: px2rem(25);
        width: px2rem(32);
        background: url('../assets/img/common/triangle_bottom.png') no-repeat 0 0;
        background-size: px2rem(32) px2rem(25);
        transition: all 0.4s ease-in-out;
        &.add {
          transform: rotate(180deg);
          transform-origin: 50% 45%;
        }
      }
      ul {
        text-align: center;
        margin-top: px2rem(10);
        // padding: px2rem(10) 0;
        background-color: white;
        max-height: px2rem(300);
        overflow-y: auto;
        & > li {
          border-bottom: 1px solid #ccc; /* 添加边框以便看到内容区域 */   
          padding:px2rem(10) 0;
          &:active {
            background-color: #f9c351;
          }
        }
      }
    }
    .school {
    }

    .grade {
      span{
        overflow: hidden; /* 隐藏超出容器的文本 */  
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .25s ease-out;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;
    transform: translateY(px2rem(-40));
  }


</style>



// WEBPACK FOOTER //
// WorkerFilter.vue?dbc54928